import { combineReducers } from "redux";
import ForgetPassword from "./auth/forgetpwd/reducer";
// Authentication
import Login from "./auth/login/reducer";
import Profile from "./auth/profile/reducer";
import Account from "./auth/register/reducer";
import businessEmailTemplatesData from "./business-email-templates/reducer";
//Dashboard
import Dashboard from "./dashboard/reducer";
import dataFormat from "./data-format/reducer";
//E-commerce
import ecommerce from "./e-commerce/reducer";
import errorInvoices from "./error-invoices/reducer";
import VATManager from "./general-info/VAT-manager/reducer";
import BusinessUnit from "./general-info/business-unit-bk/reducer";
import CurrencyManager from "./general-info/currency-manager/reducer";
import customerInvoice from "./general-info/customer/reducer";
import invoiceSymbol from "./general-info/invoice-symbol/reducer";
import PaymentMethodManager from "./general-info/payment-method-manager/reducer";
import productInvoice from "./general-info/product/reducer";
import signMethod from "./general-info/sign-method/reducer";
import userInvoice from "./general-info/user/reducer";
import invoicePos from "./invoice-pos/reducer";
import invoiceTemplate from "./invoice-template/reducer";
import issueInvoice from "./issue-invoice/reducer";
// Front
import Layout from "./layout/reducer";
//menu
import menu from "./menu/reducer";
import noticeTCT from "./notice-from-TCT/reducer";
import notificationManagement from "./notification-management/reducer";
import Portal from "./portal/reducer";
import summaryInvoiceData from "./summary-invoice-data/reducer";

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  ecommerce,
  Dashboard,
  menu,
  dataFormat,
  noticeTCT,
  notificationManagement,
  BusinessUnit,
  VATManager,
  invoiceSymbol,
  CurrencyManager,
  PaymentMethodManager,
  issueInvoice,
  invoicePos,
  Portal,
  errorInvoices,
  summaryInvoiceData,
  productInvoice,
  signMethod,
  customerInvoice,
  userInvoice,
  invoiceTemplate,
  businessEmailTemplatesData,
});

export default rootReducer;
